/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initilaState = {
  rebateProgramCode: {},
  createUtilTapeData: {
    rebateProgramCode: '',
    planType: '',
    allManufacturers: 'No',
    quarter: null,
    manufacturerId: null,
    // userId: localStorage.getItem('logInUser'),
    runProcedure: '',
  },
  errorMessages: [],
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.SET_CREATE_UTIL_TAPE_DATA: {
      return { ...state, createUtilTapeData: action.payload };
    }
    case actionTypes.UPDATE_QUARTER:
      return {
        ...state,
        createUtilTapeData: {
          ...state.createUtilTapeData,
          quarter: action.payload,
        },
      };
    case actionTypes.GET_MANUFACTURERS_BY_PQR: {
      return { ...state, manufacturersByPQR: action.payload };
    }
    case actionTypes.CALCULATE_INVOICE: {
      return { ...state, calculateInvoice: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrCUF: action.defaultQtrCUF };
    }
    case actionTypes.SET_CMS_REPORTING_GRPS: {
      return { ...state, cmsReportingGrps: action.cmsReportingGrps };
    }
    case actionTypes.REBATE_PRGBY_CMS: {
      return { ...state, rebatePrgByCMS: action.payload };
    }
    case actionTypes.SET_ERROR_MESSAGES: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.RESET_CREATE_UTILIZATION_TAP_STORE: {
      return { ...initilaState };
    }
    default:
      return state;
  }
};

export default reducer;
